export const isBuild = (): boolean => import.meta.env.PROD;
